import { useState, useEffect } from 'react';
import first from 'lodash/first';
import noop from 'lodash/noop';
import get from 'lodash/get';
import { ICvvRequirementInfo, IVGSFormInfo, getVGSErrorEntryTranslationKey } from 'obt-common';
import { getVGSError } from 'src/app/shared/utils/isVGSError';
import { useSecureInputStyling } from 'src/hooks/card-hooks/useSecureInputStyling';
import { secureInputCSS } from 'src/v1-components/shared/SecureInput.styles';

interface IProps {
  cvvRequirement: ICvvRequirementInfo;
  vgsFormInfo: IVGSFormInfo;
  elementId: string;
  cvvJsonPath: string;
}

export function useSetupCvvField({ cvvRequirement, vgsFormInfo, elementId, cvvJsonPath }: IProps) {
  const { status } = cvvRequirement;
  const colors = useSecureInputStyling();
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (!cvvJsonPath) {
      return noop;
    }

    vgsFormInfo.form.field(`#${elementId}`, {
      type: 'card-security-code',
      name: cvvJsonPath,
      autoComplete: 'cc-csc',
      validations: ['validCardSecurityCode'],
      successColor: colors.successColor,
      errorColor: colors.errorColor,
      css: { ...secureInputCSS, color: colors.color },
      hideValue: true,
    });

    const unsubscribe = vgsFormInfo.subscribe((state) => {
      const fieldState = get(state, cvvJsonPath, {});
      const vgsError = getVGSError(fieldState);

      if (!vgsError) {
        setError('');
      } else {
        const errorMessage = getVGSErrorEntryTranslationKey(first(vgsError.errorMessages)) ?? '';
        setError(errorMessage);
      }
    });

    return unsubscribe;
  }, [status, vgsFormInfo, colors, elementId, cvvJsonPath]);

  return error;
}
